export default {"src":"/_next/static/media/errorXxx.1ca14c69.svg","height":244,"width":319,"blurWidth":0,"blurHeight":0};